module.exports = __webpack_public_path__ + "img/2022_NC2.3e8d3a39.jpg";